import { type ModificationsMap, type Modifiers } from '../../types';
import { getModifiersCount } from './get-modifiers-count';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfReachedMaxModifications(params: Params) {
  const { modifiers, allModificationsMap, maxModificationsCount } = params;

  const currentModifiersCount = getModifiersCount(modifiers, allModificationsMap);

  if (maxModificationsCount === -1) {
    return false;
  }

  return currentModifiersCount >= maxModificationsCount;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  modifiers: Modifiers;
  allModificationsMap: ModificationsMap;
  maxModificationsCount: number;
};
